import { Answer } from './answer'
import { Attachment } from './attachment'
import { ReviewResultEnum } from './review-result-enum'

export interface ReviewInterface {
  /**
   * expand answer
   */
  answer?: Answer
  /**
   * 主键 ID
   */
  id: number
  /**
   * 学校 ID
   */
  schoolId: number
  /**
   * 所在学案id
   */
  handoutId?: number
  /**
   * 所在大纲id
   */
  outlineId?: number
  questionId?: number
  answerId?: number
  /**
   * 答案版本VID
   */
  answerVid?: number
  /**
   * 批改人id
   */
  reviewerId?: number
  /**
   * 答题人id
   */
  submitterId?: number
  /**
   * 批改结果
   */
  result?: ReviewResultEnum | null
  /**
   * 得分
   */
  gainedScore?: string | null
  /**
   * 评语内容
   */
  content?: string
  /**
   * 附件
   */
  attachments?: Attachment[]
  /**
   * 是否发布
   */
  isPublished?: boolean
  /**
   * 创建时间
   */
  createdAt: string
  /**
   * 更新时间
   */
  updatedAt: string
}

export class Review implements ReviewInterface {
  /**
   * expand answer
   */
  answer?: Answer
  /**
   * 主键 ID
   */
  id: number
  /**
   * 学校 ID
   */
  schoolId: number
  /**
   * 所在学案id
   */
  handoutId?: number
  /**
   * 所在大纲id
   */
  outlineId?: number
  questionId?: number
  answerId?: number
  /**
   * 答案版本VID
   */
  answerVid?: number
  /**
   * 批改人id
   */
  reviewerId?: number
  /**
   * 答题人id
   */
  submitterId?: number
  /**
   * 批改结果
   */
  result?: ReviewResultEnum | null
  /**
   * 得分
   */
  gainedScore?: string | null
  /**
   * 评语内容
   */
  content?: string
  /**
   * 附件
   */
  attachments?: Attachment[]
  /**
   * 是否发布
   */
  isPublished?: boolean
  /**
   * 创建时间
   */
  createdAt: string
  /**
   * 更新时间
   */
  updatedAt: string

  constructor(props: ReviewInterface) {
    const {
      // 重命名变量以规避与 JS 保留词的冲突, 比如 default, with
      answer: _answer,
      id: _id,
      schoolId: _schoolId,
      handoutId: _handoutId,
      outlineId: _outlineId,
      questionId: _questionId,
      answerId: _answerId,
      answerVid: _answerVid,
      reviewerId: _reviewerId,
      submitterId: _submitterId,
      result: _result,
      gainedScore: _gainedScore,
      content: _content,
      attachments: _attachments,
      isPublished: _isPublished,
      createdAt: _createdAt,
      updatedAt: _updatedAt,
      // 可能会有额外字段比如自定义字段不在类型定义中
      ...rest
    } = props

    Object.assign(this, rest)

    this.answer = _answer ? new Answer(_answer) : _answer
    this.id = _id
    this.schoolId = _schoolId
    this.handoutId = _handoutId
    this.outlineId = _outlineId
    this.questionId = _questionId
    this.answerId = _answerId
    this.answerVid = _answerVid
    this.reviewerId = _reviewerId
    this.submitterId = _submitterId
    this.result = _result
    this.gainedScore = _gainedScore
    this.content = _content
    this.attachments = _attachments
      ? _attachments.map((i) => new Attachment(i))
      : _attachments
    this.isPublished = _isPublished
    this.createdAt = _createdAt
    this.updatedAt = _updatedAt
  }
}
